import { Button } from "@/components/ui/button/button";

type Props = {
	onUpdateOptionStock: () => void;
	isValid: boolean;
	isDirty: boolean;
};

export const HeaderUpdateButton = ({ onUpdateOptionStock, isValid, isDirty }: Props) => {
	return (
		<Button variant={isValid && isDirty ? "default" : "disabled"} size={"xl"} onClick={onUpdateOptionStock}>
			保存
		</Button>
	);
};
